let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("85kOD")).then(() => parcelRequire('1pUDx'));